module.exports = __webpack_public_path__ + "img/prize0_active.f501911.png";